import instance from '../utils/axios';
import Appconfig from '../config/config';

export const getAccountStatement = async (data) => {
    const payload = {
        ...data
    };
    return await instance.post('/api/report/account-statement', payload);
};
